import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { SpreadSheetsModule } from '@grapecity/spread-sheets-angular';
import { LookupTreeComponent } from './lookup-tree.component';
import { LoaderModule } from '@core/loader/loader.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SpreadSheetsModule,
    MatDividerModule,
    MatTreeModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    LoaderModule
  ],
  declarations: [LookupTreeComponent],
  exports: [LookupTreeComponent]
})
export class LookupTreeModule {}
